import { Action } from '@ngrx/store';
import { Message } from '@model';

export enum MessageActionTypes {
  MessageLoadData = '[Message] Load data',
  MessageLoadDataSuccess = '[Message] Load success',
  MessageLoadDataFail = '[Message] Load fail',

  MessageLoadCount = '[Message] Load count data',
  MessageLoadCountSuccess = '[Message] Load count success',
  MessageLoadCountFail = '[Message] Load count fail',

  MessageSetAsRead = '[Message] Set as read',
  MessageSetAsReadSuccess = '[Message] Set as read success',
  MessageSetAsReadFail = '[Message] Set as read fail'
}

export class MessageLoad implements Action {
  readonly type = MessageActionTypes.MessageLoadData;
  constructor() {}
}

export class MessageLoadSuccess implements Action {
  readonly type = MessageActionTypes.MessageLoadDataSuccess;
  constructor(public payload: Message[]) {}
}

export class MessageLoadFail implements Action {
  readonly type = MessageActionTypes.MessageLoadDataFail;
  constructor(public payload: any) {}
}

export class MessageLoadCount implements Action {
  readonly type = MessageActionTypes.MessageLoadCount;
  constructor() {}
}

export class MessageLoadCountSuccess implements Action {
  readonly type = MessageActionTypes.MessageLoadCountSuccess;
  constructor(public payload: number) {}
}

export class MessageLoadCountFail implements Action {
  readonly type = MessageActionTypes.MessageLoadCountFail;
  constructor(public payload: any) {}
}

export class MessageSetAsRead implements Action {
  readonly type = MessageActionTypes.MessageSetAsRead;
  constructor(public payload: Message) {}
}

export class MessageSetAsReadSuccess implements Action {
  readonly type = MessageActionTypes.MessageSetAsReadSuccess;
  constructor(public payload: Message) {}
}

export class MessageSetAsReadFail implements Action {
  readonly type = MessageActionTypes.MessageSetAsReadFail;
  constructor(public payload: any) {}
}

export type MessageActions =
  | MessageLoad
  | MessageLoadSuccess
  | MessageLoadFail
  | MessageLoadCount
  | MessageLoadCountSuccess
  | MessageLoadCountFail
  | MessageSetAsRead
  | MessageSetAsReadSuccess
  | MessageSetAsReadFail;
